/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface AdvertisingFormatOverviewRowData
 */
export interface AdvertisingFormatOverviewRowData {
    /**
     * 
     * @type {string}
     * @memberof AdvertisingFormatOverviewRowData
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewRowData
     */
    campaignCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewRowData
     */
    adCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatOverviewRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewRowData
     */
    spendShare?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewRowData
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof AdvertisingFormatOverviewRowData
     */
    ctr?: number | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatOverviewRowData
     */
    cpc?: MoneyOutput | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof AdvertisingFormatOverviewRowData
     */
    cpm?: MoneyOutput | null;
    /**
     * 
     * @type {AdvertisingFormatOverviewRowDataFinanceScopeEnum}
     * @memberof AdvertisingFormatOverviewRowData
     */
    financeScope?: AdvertisingFormatOverviewRowDataFinanceScopeEnum;
}


/**
 * @export
 */
export const AdvertisingFormatOverviewRowDataFinanceScopeEnum = {
    RawProvider: 'raw_provider'
} as const;
export type AdvertisingFormatOverviewRowDataFinanceScopeEnum = typeof AdvertisingFormatOverviewRowDataFinanceScopeEnum[keyof typeof AdvertisingFormatOverviewRowDataFinanceScopeEnum];


/**
 * Check if a given object implements the AdvertisingFormatOverviewRowData interface.
 */
export function instanceOfAdvertisingFormatOverviewRowData(value: object): value is AdvertisingFormatOverviewRowData {
    return true;
}

export function AdvertisingFormatOverviewRowDataFromJSON(json: any): AdvertisingFormatOverviewRowData {
    return AdvertisingFormatOverviewRowDataFromJSONTyped(json, false);
}

export function AdvertisingFormatOverviewRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvertisingFormatOverviewRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'campaignCount': json['campaignCount'] == null ? undefined : json['campaignCount'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'spendShare': json['spendShare'] === undefined ? undefined : json['spendShare'] === null ? null : json['spendShare'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'ctr': json['ctr'] === undefined ? undefined : json['ctr'] === null ? null : json['ctr'],
        'cpc': json['cpc'] === undefined ? undefined : json['cpc'] === null ? null : MoneyOutputFromJSON(json['cpc']),
        'cpm': json['cpm'] === undefined ? undefined : json['cpm'] === null ? null : MoneyOutputFromJSON(json['cpm']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function AdvertisingFormatOverviewRowDataToJSON(json: any): AdvertisingFormatOverviewRowData {
    return AdvertisingFormatOverviewRowDataToJSONTyped(json, false);
}

export function AdvertisingFormatOverviewRowDataToJSONTyped(value?: AdvertisingFormatOverviewRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'campaignCount': value['campaignCount'],
        'adCount': value['adCount'],
        'spend': MoneyOutputToJSON(value['spend']),
        'spendShare': value['spendShare'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'ctr': value['ctr'],
        'cpc': MoneyOutputToJSON(value['cpc']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'financeScope': value['financeScope'],
    };
}

